import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import Jouluvalot from './Jouluvalot'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link
} from "react-router-dom";
import Tietosuoja from './Tietosuoja'
import Admin from './Admin';

if (window !== undefined && window.location !== undefined && new URL(window.location).searchParams !== undefined) {
  var parameters = new URL(window.location).searchParams;
  var token = parameters.get('token')
  if (token !== null) {
    localStorage.setItem("access_token", token);
    window.history.pushState('', document.title, window.location.origin)
  }

  var isLoggedIn = false;
  if (localStorage.getItem('access_token') !== null && localStorage.getItem('access_token') !== 'a') {
    isLoggedIn = true;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Router>

  <Routes>
    <Route path="/tietosuoja" element={
      <div className="m-5" style={{ color: "white" }}>
        <Tietosuoja />
      </div>
    } />
    <Route path="/admin" element={
      <Admin />
    } />
    <Route path="/" element={<App />} />
  </Routes>




</Router>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
